import { Box, Button, Card, CardContent, Typography } from "@mui/material";

interface Props {
  remark: string;
  closeForm: () => void;
}

export default function LogDetails({ remark, closeForm }: Props) {
  if (!remark) return null;

  return (
    <Box sx={{ mt: 2 }}>
      <Card variant="outlined">
        <CardContent>
          <Typography
            variant="body2"
            sx={{
              whiteSpace: "pre-wrap",
              lineHeight: 1.6,
            }}
          >
            {remark}
          </Typography>
        </CardContent>
      </Card>

      <Box sx={{ mt: 2, display: "flex", gap: 2 }}>
        <Button variant="outlined" onClick={closeForm}>
          Cancel
        </Button>
      </Box>
    </Box>
  );
}
